import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';

export const applyCtaLabel = (t: TranslationFunction, total: number) =>
  total === 1
    ? t('vacation.oss.filters.cta.total_single')
    : t('vacation.oss.filters.cta.total', { number: `${total}` });
